<template>
  <div>
    <FundTable :fundDataUrl="apiUrl"></FundTable>
  </div>
</template>

<script>
import FundTable from "@/components/fund/base/FundTable.vue";
export default {
  components: {
    FundTable,
  },
  data() {
    return {

      apiUrl : process.env.VUE_APP_API_BASE_URL + "/fundestimate/fa",
    };
  },
};
</script>